import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core'
import { BsModalService } from 'ngx-bootstrap/modal'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { DomSanitizer } from '@angular/platform-browser'
import { environment } from '../../../environments/environment'
import { StoreService } from '../../service/store.service'
import { CpmService } from '../../service/cpm.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { AuthorizeService } from '../../service/authorize.service'
import { MatMenuTrigger } from '@angular/material';
import { ToastrService } from '../../../../node_modules/ngx-toastr';
@Component({
  selector: 'app-additional-info-other',
  templateUrl: './additional-info-other.component.html',
  styleUrls: ['./additional-info-other.component.scss']
})
export class AdditionalInfoOtherComponent implements OnInit {
  @Input() companyProfile: any
  @Input() printPage

  @ViewChild('template') template: TemplateRef<any>
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  modalRef: BsModalRef
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }
  dataType = 'OtherInfo'
  subscription: Subscription
  securitySymbol
  companyStructureFilename
  companyIdPsims
  testLink
  text
  checkModified = false
  showTextWhenNull
  checkUpdate = false
  checkNulltext = false
  checkDis = false
  checkNullImg = false
  anySig
  other
  newText
  checkImgSubmit = false
  isAE
  message
  constructor(
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    private store: StoreService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private authorization: AuthorizeService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.anySig = '- Any significant information'
    const { symbol } = this.activatedRoute.snapshot.params
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.companyIdPsims = response['companyIdPsims']
        this.securitySymbol = response['securitySymbol']
        this.text = response['otherInfo']
        this.other = response['otherInfoFilename']
        this.testLink = `${environment.cpmBaseUrl}/download?type=${this.dataType}&id=${this.companyIdPsims}`
        this.isAE = response['ae']
        this.onChangeData()
      })
  }

  get isUserHasPermission(): Boolean {
    return (
      this.authorization.hasRole('COMPINFO_EDIT')
    )
  }

  checkNullText() {
    if (this.text === null || this.text === '') {
      this.checkNulltext = true
    } else {
      this.checkNulltext = false
    }
  }

  async onChangeData() {
    this.checkNullText();
    if (this.other === null) {
      this.checkNullImg = true
    } else {
      this.checkNullImg = false
    }
    this.newText = this.text
  }

  modifiedText() {
    return (this.checkModified = true)
  }
  checkDisplay() {
    return (this.checkDis = true)
  }

  checkCancel() {
    this.newText = this.text
    return (this.checkUpdate = false), (this.checkDis = false)
  }

  checkSubmit() {
    this.text = this.newText
    this.updateToSecprofile()
    this.checkNullText();
    return (this.checkUpdate = true), (this.checkDis = false)
  }

  async updateToSecprofile() {
    const body = {
      companyId: this.companyIdPsims,
      fieldName: 'otherInfo',
      fieldValue: this.text
    }
    await this.cpmService.updateCompanyProfile(body).then(response => {
      this.message = response.status
      this.message === 'OK' ? (this.toastr.success('การบันทึกรายการสำเร็จแล้ว')) : (this.message = 'บันทึกรายการไม่สำเร็จ')
    },
      error => {
        this.message = 'บันทึกรายการไม่สำเร็จ'
        this.openModalError(this.templateSaved)
      })
  }

  uploadFile() {
    const width = 600
    const height = 600
    const left = screen.width / 2 - width / 2
    const top = screen.height / 2 - height / 2
    this.openModal(this.template)
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg' })
    )
  }

  closeModal() {
    this.modalRef.hide()
  }

  getLink(companyIdPsims) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.cpmBaseUrl}/download?type=${this.dataType}&id=${companyIdPsims}&srcImg=${new Date().getTime()}`
    )
  }

  testClick(symbol) {
    this.other = symbol
    this.checkImgSubmit = true
    this.checkNullImg = false
  }

  reupload() {
    $('#upload').click()
  }

  openImg() {
    window.open(this.testLink)
  }
  openModalError(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.modalConfig, { class: 'modal-sm' })
    )
  }
  clickEditDropdown(event: Event) {
    $(event.target)
      .closest('div')
      .next()
      .toggleClass('show')
  }

  mourseLeaveMenu() {
    $(event.target)
      .find('#editItemListAdditionalOth')
      .removeClass('show')
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/additional-info-other/additional-info-other.component.ts